import { render, staticRenderFns } from "./commonPrimary.vue?vue&type=template&id=3eb77124&"
import script from "./commonPrimary.vue?vue&type=script&lang=js&"
export * from "./commonPrimary.vue?vue&type=script&lang=js&"
import style0 from "./commonPrimary.vue?vue&type=style&index=0&id=3eb77124&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports